// import React, { useEffect, useState } from "react";
// import { MdOutlineAccountBalanceWallet } from "react-icons/md";
// import { RxLapTimer } from "react-icons/rx";
// import { FaUserCheck, FaUserSlash } from "react-icons/fa";
// import axios from "axios";
// import { BASE_URL, USER_URL } from "../../constant/api";
// import { Link } from "react-router-dom";
// import ConfirmationModal from "../../components/AdminApproval/ConfirmationModal"; // Import the modal component

// function AdminBannerApproval() {
//   const [filter, setFilter] = useState("All");
//   const [products, setProducts] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [actionType, setActionType] = useState("");

//   // Fetch products on component mount
//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await USER_URL.get(`/products/admin/banners/`);
//         console.log(response);

//         if (response.data?.Data) {
//           setProducts(response.data.Data);
//         }
//       } catch (error) {
//         console.error("Error fetching products:", error.message || error);
//       }
//     };
//     fetchProducts();
//   }, []);

//   // Open the confirmation modal
//   const openModal = (product, action) => {
//     setSelectedProduct(product);
//     setActionType(action);
//     setModalOpen(true);
//   };

//   // Handle modal confirmation
//   const handleConfirm = () => {
//     if (selectedProduct) {
//       setProducts((prevProducts) =>
//         prevProducts.map((product) =>
//           product.id === selectedProduct.id
//             ? {
//                 ...product,
//                 status: actionType === "Approve" ? "Approved" : "Rejected",
//               }
//             : product
//         )
//       );
//       setModalOpen(false);
//     }
//   };

//   // Filter products based on selected filter
//   const filteredProducts =
//     filter === "All"
//       ? products
//       : products.filter((product) => product.status === filter);

//   return (
//     <div className="container mx-auto">
//       {/* Tabs Section */}
//       <div className="flex items-center justify-between border-b border-gray-300 w-full mb-5 mt-5">
//         {["All", "Approved", "Rejected", "Pending"].map((status) => (
//           <button
//             key={status}
//             onClick={() => setFilter(status)}
//             className={`flex flex-col items-center gap-1 ${
//               filter === status ? "text-green-600" : "text-gray-400"
//             }`}
//           >
//             <div className="flex items-center gap-2">
//               {status === "All" && <MdOutlineAccountBalanceWallet className="text-xl" />}
//               {status === "Approved" && <FaUserCheck className="text-xl" />}
//               {status === "Rejected" && <FaUserSlash className="text-xl" />}
//               {status === "Pending" && <RxLapTimer className="text-xl" />}
//               <span className="font-semibold">{status}</span>
//             </div>
//             {filter === status && (
//               <div className="w-full h-1 bg-green-600"></div>
//             )}
//           </button>
//         ))}
//       </div>

//       {/* Table Section */}
//       <div className="overflow-x-auto mt-4">
//         <table className="w-full text-left">
//           <thead>
//             <tr>
//               <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                 Item No
//               </th>
//               <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                 Seller Name
//               </th>
//               <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                 Banner Name
//               </th>
//               <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                 Status
//               </th>
//               <th className="py-3 px-4"></th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredProducts.map((product, index) => (
//               <tr key={product.id} className="border-gray-300">
//                 <td className="py-3 px-4">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//                     {index + 1}
//                   </div>
//                 </td>
//                 <td className="py-3 px-4">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//                     {product.name || "Seller"}
//                   </div>
//                 </td>
//                 <td className="py-3 px-4">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//                     {product.title || "Banner"}
//                   </div>
//                 </td>
//                 <td className="py-3 px-4">
//                   <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//                     {product.status || "Pending"}
//                   </div>
//                 </td>
//                 <td className="py-3 px-4">
//                   <button
//                     onClick={() =>
//                       openModal(product, product.status === "Approved" ? "Reject" : "Approve")
//                     }
//                     className={`${
//                       product.status === "Approved"
//                         ? "text-red-600 border-red-600 hover:bg-red-100"
//                         : "text-green-600 border-green-600 hover:bg-green-100"
//                     } border rounded-lg px-4 py-2 text-sm font-medium w-[100px]`}
//                   >
//                     {product.status === "Approved" ? "Reject" : "Approve"}
//                   </button>
//                   <Link
//                     to={`/admin/approval/banner/view/${product.id}`}
//                     className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100 ml-5"
//                   >
//                     View
//                   </Link>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* Separate Confirmation Modal */}
//       <ConfirmationModal
//         isOpen={modalOpen}
//         onClose={() => setModalOpen(false)}
//         onConfirm={handleConfirm}
//         action={actionType}
//         product={selectedProduct}
//       />
//     </div>
//   );
// }

// export default AdminBannerApproval;



import React, { useEffect, useState } from "react";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { RxLapTimer } from "react-icons/rx";
import { FaUserCheck, FaUserSlash } from "react-icons/fa";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { Link } from "react-router-dom";
import ConfirmationModal from "../../components/AdminApproval/ConfirmationModal";
import ScaleLoader from "react-spinners/ScaleLoader"; // ✅ Import the spinner

function AdminBannerApproval() {
  const [filter, setFilter] = useState("All");
  const [products, setProducts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [actionType, setActionType] = useState("");
  const [loading, setLoading] = useState(true); // ✅ Add loading state

  // ✅ Fetch banners with filtering
  const fetchProducts = async () => {
    setLoading(true); // Start loading
    try {
      const response = await USER_URL.get(`/products/admin/banners/`);

      if (response.data?.Data) {
        setProducts(response.data.Data);
      }
    } catch (error) {
      console.error("Error fetching products:", error.message || error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // 🚀 Fetch on component mount & on filter change
  useEffect(() => {
    fetchProducts();
  }, [filter]);

  // ✅ Open the confirmation modal
  const openModal = (product, action) => {
    setSelectedProduct(product);
    setActionType(action);
    setModalOpen(true);
  };

  // ✅ Handle banner status update
  const handleConfirm = async () => {
    if (selectedProduct) {
      try {
        const newStatus = actionType === "Approve" ? "Approved" : "Rejected";
        await USER_URL.post(
          `/products/admin/banners/${selectedProduct.id}/`,
          { status: newStatus }
        );

        // Update the UI immediately after API call
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.id === selectedProduct.id
              ? { ...product, status: newStatus }
              : product
          )
        );
      } catch (error) {
        console.error("Error updating status:", error.message || error);
      } finally {
        setModalOpen(false);
      }
    }
  };

  // Filter products based on selected filter
  const filteredProducts =
    filter === "All"
      ? products
      : products.filter((product) => product.status === filter);

  return (
    <div className="container mx-auto">
      {/* Tabs Section */}
      <div className="flex items-center justify-between border-b border-gray-300 w-full mb-5 mt-5">
        {["All", "Approved", "Rejected", "Pending"].map((status) => (
          <button
            key={status}
            onClick={() => setFilter(status)}
            className={`flex flex-col items-center gap-1 ${
              filter === status ? "text-green-600" : "text-gray-400"
            }`}
          >
            <div className="flex items-center gap-2">
              {status === "All" && <MdOutlineAccountBalanceWallet className="text-xl" />}
              {status === "Approved" && <FaUserCheck className="text-xl" />}
              {status === "Rejected" && <FaUserSlash className="text-xl" />}
              {status === "Pending" && <RxLapTimer className="text-xl" />}
              <span className="font-semibold">{status}</span>
            </div>
            {filter === status && (
              <div className="w-full h-1 bg-green-600"></div>
            )}
          </button>
        ))}
      </div>

      {/* Loading Spinner */}
      {loading ? (
        <div className="flex justify-center items-center h-96">
          <ScaleLoader color="#FFAE00" size={60} /> {/* Spinner */}
        </div>
      ) : (
        <>
          {/* Table Section */}
          <div className="overflow-x-auto mt-4">
            <table className="w-full text-left">
              <thead>
                <tr>
                  <th className="py-3 px-2 text-green-500 text-sm font-medium">
                    Item No
                  </th>
                  <th className="py-3 px-2 text-green-500 text-sm font-medium">
                    Seller Name
                  </th>
                  <th className="py-3 px-2 text-green-500 text-sm font-medium">
                    Banner Name
                  </th>
                  <th className="py-3 px-2 text-green-500 text-sm font-medium">
                    Start Date
                  </th>
                  <th className="py-3 px-2 text-green-500 text-sm font-medium">
                    End Date
                  </th>
                  <th className="py-3 px-2 text-green-500 text-sm font-medium">
                    Status
                  </th>
                  <th className="py-3 px-2"></th>
                </tr>
              </thead>
              <tbody>
                {filteredProducts.map((product, index) => (
                  <tr key={product.id} className="border-gray-300">
                    <td className="py-3 px-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {index + 1}
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.name || "Seller Name"}
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.title || "Banner"}
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.start_date || "Banner"}
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.end_date || "Banner"}
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <div
                        className={`rounded-lg border px-4 py-2 text-sm ${
                          product.status === "Approved"
                            ? "text-green-600 border-green-600"
                            : product.status === "Rejected"
                            ? "text-red-600 border-red-600"
                            : "text-yellow-600 border-yellow-600"
                        }`}
                      >
                        {product.status || "Pending"}
                      </div>
                    </td>
                    <td className="py-3 px-2">
                      <button
                        onClick={() =>
                          openModal(
                            product,
                            product.status === "Approved" ? "Reject" : "Approve"
                          )
                        }
                        className={`${
                          product.status === "Approved"
                            ? "text-red-600 border-red-600 hover:bg-red-100"
                            : "text-green-600 border-green-600 hover:bg-green-100"
                        } border rounded-lg px-4 py-2 text-sm font-medium w-[100px]`}
                      >
                        {product.status === "Approved" ? "Reject" : "Approve"}
                      </button>
                      <Link
                        to={`/admin/approval/banner/view/${product.id}`}
                        className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100 ml-5"
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
        action={actionType}
        product={selectedProduct}
      />
    </div>
  );
}

export default AdminBannerApproval;

